<!--
Program: Approval Sample List
Author: SDL
Description: Approval Sample List
-->
<template>
  <!-- SUB Contents -->
  <div class="main_content_wrapper">
    <sdl-breadcrumb v-show="false"></sdl-breadcrumb>
    <div class="com_head">
      <h4 class="main_title" v-html="welcomeTitle"></h4>
      <div class="button">
        <label class="info">{{ userTimezone }}</label>
      </div>
    </div>
    <div class="dp_main_flex">
      <div class="dp_block cols_75">
        <div class="block_line">
          <!-- list_wrap -->
          <div class="list_wrap">
            <div class="com_head">
              <h4>{{ $t('cop.home.title.myproject') }}</h4>
              <button class="btn btn_icon ico_link" title="More" @click="onMenuLinkClick(menuLinks['myProject'])"></button>
            </div>
            <div class="scop_grid h_auto" style="height:203px;">
              <table v-columnResize>
                <colgroup>
                  <col width="140px"/>
                  <col width="180px"/>
                  <col width="100px"/>
                  <col width="100px"/>
                  <col width="260px"/>
                  <col width="100px"/>
                  <col width="100px"/>
                  <col width="120px"/>
                </colgroup>
                <thead>
                <tr>
                  <th>{{ $t('cop.home.label.projectName') }}</th>
                  <th>{{ $t('cop.home.label.projectLeader') }}</th>
                  <th>{{ $t('cop.home.label.csp') }}</th>
                  <th>{{ $t('cop.home.label.environment') }}</th>
                  <th>{{ $t('cop.home.label.accountId') }}</th>
                  <th>{{ $t('cop.home.label.user') }}</th>
                  <th>{{ $t('cop.home.label.role') }}</th>
                  <th>
                    {{ $t('cop.home.label.status') }}
                    <v-popover trigger="hover" boundariesElement="window">
                      <button type="button" class="btn btn_icon ico_tooltip"></button>
                      <template slot="popover">
                        <!--tooltip 영역-->
                        <div class="tooltip_con">
                          <ul>
                            <li><span class="st_label major">DRAFT</span></li>
                            <li><span class="st_label review">INREVIEW</span></li>
                            <li><span class="st_label active">ACTIVE</span></li>
                            <li><span class="st_label inactive">INACTIVE</span></li>
                            <li><span class="st_label drop">DROP</span></li>
                          </ul>
                        </div>
                        <!--tooltip 영역-->
                      </template>
                    </v-popover>
                  </th>
                </tr>
                </thead>
                <tbody v-if="projectList && (projectList.length > 0)">
                <tr v-for="(row,idx) in projectList" :key="idx" class="link" @click="onMyProjectDetailClick(row)">
                  <td class="tl link" :title="row.projectName">{{ row.projectName }}</td>
                  <td :class="{'tl': row.projectLeader}" :title="row.projectLeader ? `${row.projectLeader} (${row.projectLeaderKnoxId})` : '-'">{{ row.projectLeader ? `${row.projectLeader} (${row.projectLeaderKnoxId})` : '-' }}</td>
                  <td :title="row.cspName">{{ _.isEmpty(row.cspName) ? '-' : row.cspName }}</td>
                  <td :title="row.envName">{{ _.isEmpty(row.envName) ? '-' : row.envName }}</td>
                  <td :class="{'tl': !_.isEmpty(row.accountId)}">{{ _.isEmpty(row.accountId) ? '-' : row.accountId }}</td>
                  <td class="link" :title="row.memberCount" @click.stop="onMyProjectDetailClick(row)">{{ row.memberCount }}</td>
                  <td class="link" :title="row.roleCount" @click.stop="onMenuLinkClick(menuLinks['myProjectRole'])">{{ row.roleCount }}</td>
                  <td :title="row.projectState" v-html="row.projectStateBeautify"></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="8">{{ $t('sdl.common.message.noResult') }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- //list_wrap -->
        </div>
      </div>
      <div class="dp_block">
        <div class="block_line">
          <div class="com_head">
            <h4>{{ $t('cop.home.title.mycsp') }}</h4>
          </div>
          <div class="download_wrap">
            <div class="download_list">
              <button type="button" class="btn btn_client_download bg_none on">{{ $t('cop.home.label.mycsp.cspLogin') }}</button>
              <button type="button" class="btn btn_down_linked aws" @click="onCspLoginClick('AWS', cspLinks['aws'], true)">{{ $t('cop.home.label.mycsp.awsConsole') }}</button>
              <button type="button" class="btn btn_down_linked azure" @click="onCspLoginClick('Azure', cspLinks['azure'], true)">{{ $t('cop.home.label.mycsp.azureConsole') }}</button>
              <button type="button" class="btn btn_down_linked gcp" @click="onCspLoginClick('GCP', cspLinks['gcp'], true)">{{ $t('cop.home.label.mycsp.gcpConsole') }}</button>
              <button type="button" class="btn btn_down_linked oci" @click="onCspLoginClick('OCI', cspLinks['oci'], true)">{{ $t('cop.home.label.mycsp.ociConsole') }}</button>
              <button type="button" class="btn btn_down_linked ncp" @click="ncpPopup">{{ $t('cop.home.label.mycsp.ncpConsole') }}</button>
              <button type="button" class="btn btn_down_linked ali" @click="onCspLoginClick('ALI', cspLinks['ali'], true)">{{ $t('cop.home.label.mycsp.aliConsole') }}</button>
              <button type="button" class="btn btn_down_linked ali" @click="onCspLoginClick('ALI_CN', cspLinks['ali_cn'], true)">{{ $t('cop.home.label.mycsp.alicnConsole') }}</button>
              <button type="button" class="btn btn_down_linked scp" @click="onCspLoginClick('SCP', cspLinks['scp'], true)">{{ $t('cop.home.label.mycsp.scpConsole') }}</button>
              <button type="button" class="btn btn_down_linked aws" @click="onCspLoginClick('AWS_CN', cspLinks['aws_cn'], true)">{{ $t('cop.home.label.mycsp.awscnConsole') }}</button>
              <button type="button" class="btn btn_down_linked spc" @click="onCspLoginClick('SPC', cspLinks['spc'], true)">{{ $t('cop.home.label.mycsp.spcConsole') }}</button>
              <button type="button" class="btn btn_down_linked azure" @click="onCspLoginClick('Azure China', cspLinks['azure_cn'], true)">{{ $t('cop.home.label.mycsp.azureCnConsole') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dp_main_flex">
      <div class="dp_block cols_100">
        <div class="block_line">
          <!-- list_wrap -->
          <div class="list_wrap">
            <div class="com_head">
              <h4>{{ $t('cop.home.title.myworkrequest') }}</h4>
              <button class="btn btn_icon ico_link" title="More" @click="onMenuLinkClick(menuLinks['myWorkRequest'])"></button>
            </div>
            <div class="scop_grid h_auto" style="height:162px;">
              <table>
                <colgroup>
                  <col width="180px" />
                  <col width="220px" />
                  <col width="140px" />
                  <col width="150px" />
                  <col width="120px" />
                  <col width="120px" />
                </colgroup>
                <thead>
                <tr>
                  <th>{{ $t('cop.home.label.requestType') }}</th>
                  <th>{{ $t('cop.home.label.projectName') }}</th>
                  <th>{{ $t('cop.home.label.requestedBy') }}</th>
                  <th>{{ $t('cop.home.label.requestedDate') }}</th>
                  <th>
                    {{ $t('cop.home.label.approvalStatus') }}
                    <v-popover trigger="hover" boundariesElement="window">
                      <button type="button" class="btn btn_icon ico_tooltip"></button>
                      <template slot="popover">
                        <!--tooltip 영역-->
                        <div class="tooltip_con">
                          <ul>
                            <li><span class="st_label inprogress">In Progress</span></li>
                            <li><span class="st_label rejected">Rejected</span></li>
                            <li><span class="st_label completed">Completed</span></li>
                            <li><span class="st_label submitted">Cancelled</span></li>
                          </ul>
                        </div>
                        <!--tooltip 영역-->
                      </template>
                    </v-popover>
                  </th>
                  <th>
                    {{ $t('cop.home.label.requestStatus') }}
                    <v-popover trigger="hover" boundariesElement="window">
                      <button type="button" class="btn btn_icon ico_tooltip"></button>
                      <template slot="popover">
                        <!--tooltip 영역-->
                        <div class="tooltip_con">
                          <ul>
                            <li><span class="st_bg inprogress">In Progress</span></li>
                            <li><span class="st_bg completed">Completed</span></li>
                          </ul>
                        </div>
                        <!--tooltip 영역-->
                      </template>
                    </v-popover>
                  </th>
                </tr>
                </thead>
                <tbody v-if="workRequestList && (workRequestList.length > 0)">
                <tr v-for="(row,idx) in workRequestList" :key="idx" class="link" @click.stop="onMyWorkRequestDetailClick(row)">
                  <td class="tl" :title="row.requestType">{{ row.requestType }}</td>
                  <td :class="{'tl': !_.isEmpty(row.projectName)}" :title="row.projectName">{{ _.isEmpty(row.projectName) ? '-' : row.projectName }}</td>
                  <td class="tl" :title="row.requestBy ? `${row.requestBy} (${row.requestByKnoxId})` : 'SYSTEM'">{{ row.requestBy ? `${row.requestBy} (${row.requestByKnoxId})` : 'SYSTEM' }}</td>
                  <td :title="row.requestDate | dateFormat">{{ row.requestDate | dateFormat }}</td>
                  <td :title="row.approvalStatus" v-html="row.approvalStatusBeautify"></td>
                  <td :title="row.requestStatus" v-html="row.requestStatusBeautify"></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="6">{{ $t('sdl.common.message.noResult') }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- //list_wrap -->
        </div>
      </div>
    </div>
    <div class="dp_main_flex">
      <div class="dp_block cols_25">
        <div class="block_line">
          <div class="com_head">
            <h4>{{ $t('cop.home.title.notice') }}</h4>
            <button class="btn btn_icon ico_link" title="More" @click="onMenuLinkClick(menuLinks['boardNotice'])"></button>
          </div>
          <ul v-if="noticeList && (noticeList.length > 0)">
            <li v-for="(row,idx) in noticeList" :key="idx" @click="onBoardNoticeDetailClick(row)" :class="[ row.deleteYn ? 'no_exist' : '' ]">
              <p :title="row.postTitle">{{ row.postTitle }}</p>
              <p :title="row.registDate | dateFormat">{{ row.registDate | dateFormat }}</p>
            </li>
          </ul>
          <ul v-else>
            {{ $t('sdl.common.message.noResult') }}
          </ul>
        </div>
      </div>
      <div class="dp_block cols_25">
        <div class="block_line">
          <div class="com_head">
            <h4>{{ $t('cop.home.title.qna') }}</h4>
            <button class="btn btn_icon ico_link" @click="onMenuLinkClick(menuLinks['boardQna'])"></button>
          </div>
          <ul v-if="qnaList && (qnaList.length > 0)">
            <li v-for="(row,idx) in qnaList" :key="idx" @click="onBoardQnaDetailClick(row)" :class="[!row.publicYn ? 'secret' : '', row.deleteYn ? 'no_exist' : '' ]">
              <p :title="row.postTitle">{{ row.postTitle }}</p>
              <p :title="row.registDate | dateFormat">{{ row.registDate | dateFormat }}</p>
            </li>
          </ul>
          <ul v-else>
            {{ $t('sdl.common.message.noResult') }}
          </ul>
        </div>
      </div>
      <div class="dp_block cols_25">
        <div class="block_line">
          <div class="com_head">
            <h4>{{ $t('cop.home.title.tutorial') }}</h4>
          </div>
          <ul class="start_tutorial">
            <li v-for="(row,idx) in tutorialList" :key="idx" @click="onTutorialClick(row)">
              <p :title="row.title">{{ row.title }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="dp_block cols_25">
        <div class="block_line">
          <div class="com_head">
            <h4>{{ $t('cop.home.title.quickLinks') }}</h4>
          </div>
          <ul class="quick_link"><!-- 2개일경우 class="quick_link two"  4개일경우 class="quick_link four" -->
            <li v-for="(row,idx) in quickLinkList" :key="idx" @click="onQuickLinkClick(row)">
              <p :title="row.title">{{ row.title }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import store from '@/vuex/store'
import { SDLUtil, RequestUtil } from '@/utils'
import { syslinkService } from '@/service';
import SysLinkConstants from '@/constants/SysLinkConstants';
import CodeSelect from '@/components/common/code/CodeSelect.vue'
import NcpRolePopup from "@/components/view/admin/main/NcpRolePopup.vue";

export default {
  components: {
    CodeSelect,
  },
  data() {
    return {
      /* User Information */
      userInfo: {},
      userName: '',
      /* User Data */
      projectList: [],
      workRequestList: [],
      noticeList: [],
      qnaList: [],
      tutorialList: [{
        tag: 'onboarding',
        title: SDLUtil.getMsgProp('cop.home.label.tutorial.keyFeatures'),
        href: '',
      }, {
        tag: 'manual',
        title: SDLUtil.getMsgProp('cop.home.label.tutorial.userManual'), // 'Requesting Project creation',
        href: '',
      }],
      quickLinkList: [{
        title: SDLUtil.getMsgProp('cop.home.label.quicklinks.cloudInOne'),
        href: `${SDLUtil.getExternalUrl('CLOUD_IN_ONE')}`,
      }, {
        title: SDLUtil.getMsgProp('cop.home.label.quicklinks.ipa'),
        href: `${SDLUtil.getExternalUrl('IPA')}${SDLUtil.getExternalUrl('IPA_AUTH_ENDPOINT')}`,
      }, {
        title: SDLUtil.getMsgProp('cop.home.label.quicklinks.itvoc'),
        href: `${SDLUtil.getExternalUrl('ITVOC')}`,
      }],
      /* Links */
      cspLinks: {
        'aws': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('AWS_KEYCLOCK')}`,
        'azure': `${SDLUtil.getExternalUrl('AZURE')}`,
        'azure_cn': `${SDLUtil.getExternalUrl('AZURE_CN')}`,
        'gcp': `${SDLUtil.getExternalUrl('GCP')}`,
        'oci': `${SDLUtil.getExternalUrl('OCI')}`,
        'ncp': `${SDLUtil.getExternalUrl('NCP')}`,
        'ali': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('ALI_KEYCLOAK_REALMS')}`,
        'ali_cn': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('ALI_CN_KEYCLOAK_REALMS')}`,
        'scp': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('SCP_KEYCLOAK_REALMS')}`,
        'aws_cn': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('AWS_CN_KEYCLOAK_REALMS')}`,
        'spc': `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl('SPC_KEYCLOAK_REALMS')}`,
      },
      menuLinks: {
        'myProject': '/std/project/myProject/list',
        // 'myProjectRole': '/coa/roles/RoleManagement',
        'myProjectRole': '/coa/roles/MyProjectRole',
        'myWorkRequest': '/std/project/myRequest/list',
        'boardNotice': '/board/notice/user/list',
        'boardFaq': '/board/faq/user/list',
        'boardQna': '/board/voc/user/list',
      },
      viewLinks: {
        'myProjectDetail': '/std/project/myProject/detail',
        'myProjectActiveDetail': '/std/project/myProject/activeDetail',
        'myWorkRequestDetail': '/std/project/myRequest/requestDetail',
        'boardNoticeDetail': '/board/notice/user/view',
        'boardFaqDetail': '/board/faq/user/view',
        'boardQnaDetail': '/board/voc/user/view',
      },
    }
  },
  computed: {
    ...mapGetters({
      locale: 'getLocale',
      gmt: 'getGMT',
      mainPath: 'getMainPath',
      menus: 'getMenus',
      myHomeProjectList: 'getMyHomeProjectList',
      myHomeWorkRequestList: 'getMyHomeWorkRequestList',
      myHomeNoticeList: 'getMyHomeNoticeList',
      myHomeQnaList: 'getMyHomeQnaList',
    }),
    welcomeTitle() {
      return SDLUtil.getMsgProp('cop.home.title.welcome', [this.userName])
    },
    userTimezone() {
      return `${this.userInfo.timeZoneId}, ${this.userInfo.timeZoneCode}`
    },
    _() {
      return _;
    },
  },
  watch: {
    locale: () => this.onLocaleChange(),
    gmt: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.onTimezoneChange(newVal)
      }
    },
    myHomeProjectList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.projectList = this.merge(newVal, x => ({
          projectUid: x.projectUid || '',
          projectName: x.projectName || '',
          projectLeader: x.projectLeader || '',
          projectLeaderKnoxId: x.projectLeaderKnoxId || '',
          cspName: x.cspName || '',
          envName: x.envName || '',
          accountId: x.accountId || '',
          roleCount: _.isEmpty(x.accountId || x.roleCount) ? '' : `${x.roleCount} EA`,
          memberCount: _.isEmpty(x.accountId || x.memberCount) ? '' : `${x.memberCount} person(s)`,
          projectState: (x.projectStateCode || '').toUpperCase(),
          projectStateBeautify: {
            'DRAFT': `<span class="st_label major">DRAFT</span>`,
            'INREVIEW': `<span class="st_label review">INREVIEW</span>`,
            'ACTIVE': `<span class="st_label active">ACTIVE</span>`,
            'INACTIVE': `<span class="st_label inactive">INACTIVE</span>`,
            'DROP': `<span class="st_label drop">DROP</span>`,
          }[
            (((x.projectStateCode === 'INREVIEW' && x.projectSubStatusCd === 'plan') ? 'DRAFT'
                : (x.projectStateCode === 'ACTIVE' && x.projectSubStatusCd === 'inreview') ? 'INREVIEW'
                  : x.projectStateCode)
              || '').toUpperCase()
            ] || ''
        })) || [];
      },
    },
    myHomeWorkRequestList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.workRequestList = this.merge(newVal, x => ({
          requestUid: x.requestUid || '',
          requestType: x.requestType || '',
          requestBy: x.requestBy || '',
          requestByKnoxId: x.requestByKnoxId || '',
          requestDate: x.requestDate || '',
          projectName: x.projectName || '',
          approvalStatus: {
            'INPROCESS': 'In Progress',
            'REJECTED': 'Rejected',
            'COMPLETED': 'Completed',
            'CANCELLED': 'Cancelled',
          }[(x.approvalStatus || '').toUpperCase()] || '',
          approvalStatusBeautify: {
            'INPROCESS': '<span class="st_label inprogress">In Progress</span>',
            'REJECTED': '<span class="st_label rejected">Rejected</span>',
            'COMPLETED': '<span class="st_label completed">Completed</span>',
            'CANCELLED': '<span class="st_label submitted">Cancelled</span>',
          }[(x.approvalStatus || '').toUpperCase()] || '',
          requestStatus: {
            '0': 'In Progress',
          }[(x.requestStatus || '')] || 'Completed',
          requestStatusBeautify: {
            '0': '<span class="st_bg inprogress">In Progress</span>',
          }[(x.requestStatus || '')] || '<span class="st_bg completed">Completed</span>',
        })) || []
      },
    },
    myHomeNoticeList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.noticeList = this.merge(newVal.rows, x => ({
          postId: x.postId || '',
          postTitle: x.postTitle || '',
          registDate: x.regDate,
          deleteYn: x.deleteYn,
        })) || []
      },
    },
    myHomeQnaList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.qnaList = this.merge(newVal.rows, x => ({
          postId: x.postId || '',
          postTitle: x.postTitle,
          regrId: x.regrId,
          registDate: x.regDate,
          publicYn: x.publicYn,
          deleteYn: x.deleteYn,
        })) || []
      },
    },
  },
  methods: {
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 컴포넌트 init (init component)
     */
    init() {
      this.userInfo = SDLUtil.getLoginedUserInfo()
      this.onLocaleChange()
      this.onTimezoneChange()

      this.fetch('GET_MYHOME_PROJECT_LIST')
      this.fetch('GET_MYHOME_WORKREQUEST_LIST')
      this.fetch('GET_MYHOME_NOTICE_LIST', { pageIndex: 1, pageSize: 3 })
      this.fetch('GET_MYHOME_QNA_LIST', { pageIndex: 1, pageSize: 3 })
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: fetch
     */
    fetch(action, params) {
      this.$store.dispatch(action, {
        locale: this.locale,
        ...(params || {}),
      })
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: merge
     */
    merge(src, assign) {
      return Array.isArray(src) && src.map(x => assign(x))
    },


    /** Events --------------------*/

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onMenuLinkClick
     */
    onMenuLinkClick(path) {
      path = path || ''

      store.commit('PARAMS', {})
      this.$router.push({ path: path })

      // If the moving component is the same, refresh is required
      const fromComponentName = this.$route.meta.componentName
      const toMenu = _.find(this.menus, ['menuUrl', path])

      if (fromComponentName && toMenu && (fromComponentName === toMenu.componentName)) {
        this.$emit('router-reload')
      }
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onMyProjectDetailClick
     */
    async onMyProjectDetailClick(row) {
      const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/std/prj/selectProjectState/${row.projectUid}`)

      if (data && data.data && (data.data.data === 'ACTIVE' || data.data.data === 'INACTIVE')) {
        this.$router.push({ path: `${this.$context}${this.viewLinks['myProjectActiveDetail'] || ''}/${row.projectUid}` })
      } else {
        this.$router.push({ path: `${this.$context}${this.viewLinks['myProjectDetail'] || ''}/${row.projectUid}` })
      }
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onMyWorkRequestDetailClick
     */
    onMyWorkRequestDetailClick(row) {
      this.$router.push({
        path: `${this.$context}${this.viewLinks['myWorkRequestDetail'] || ''}/${row.requestUid}`,
        query: { requestClsCd: row.requestClsCode },
      })
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onBoardNoticeDetailClick
     */
    onBoardNoticeDetailClick(row) {
      if (row.deleteYn) return;
      this.$router.push(`${this.$context}${this.viewLinks['boardNoticeDetail']}/${row.postId}/default`)
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onBoardQnaDetailClick
     */
    onBoardQnaDetailClick(row) {
      if (row.deleteYn) return;
      if (!row.publicYn && !(row.regrId === this.userInfo.userId || SDLUtil.isSystemAdmin())) {
        SDLUtil.alert('sdl.board.message.privateArticle');
        return;
      }
      this.$router.push(`${this.$context}${this.viewLinks['boardQnaDetail']}/${row.postId}/default`)
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onTutorialClick
     */
    onTutorialClick(row) {
      const map = {
        'onboarding': () => this.$eventBus.$emit("showOnBoarding", { hideDontShowAgain: true }),
        'manual': () => window.open(`${this.$context}/manual`, '_blank'),
      }

      map[row.tag] && map[row.tag]()
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onQuickLinkClick
     */
    onQuickLinkClick(row) {
      const url = (row && row.href) || '';
      syslinkService.openSysLink(url);
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onCspLoginClick
     */
    onCspLoginClick(cspType, url) {
      this.$store.dispatch('INSERT_COA_LOG', cspType);
      window.open(url.startsWith('http') ? url : `https://${url}`, '_blank')
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onLocalChange
     */
    onLocaleChange() {
      const found = [
        { locale: 'ko_KR', name: this.userInfo.userName },
        { locale: 'en_US', name: this.userInfo.userNameEn },
      ].find(x => _.isEqual(x.locale, this.locale)) || {}

      this.userName = found.name || ''
    },

    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: onTimezoneChange
     */
    onTimezoneChange(newVal) {
      this.userInfo = SDLUtil.getLoginedUserInfo()
    },
    ncpPopup() {
      SDLUtil.show(
        NcpRolePopup,
        {
          rtnFunc: () => {
            this.insertCoaLog('NCP');
          },
        },
        {
          sizeClass: 'small',
        },
      );
    },
    insertCoaLog(cspType) {
      this.$store.dispatch('INSERT_COA_LOG', cspType);
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.lazyLoad = true
  },
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainIndexPage.vue